export { Collapse } from 'antd'
export type { CollapseProps, CollapsePanelProps } from 'antd'
